import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../axiosBaseQuery";


const StorageApi = createApi({
    reducerPath: "core/hydrodynamic/storage/groundwater",
    baseQuery: axiosBaseQuery,
    tagTypes: ["parameterGroundwaterStorage"],
    endpoints: (builder) =>({
        parameterGroundStorageFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['parameterGroundwaterStorage'],
            query: (query = '') => ({
                url: "core/hydrodynamic/storage/groundwater" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        parameterGroundStorageCreate: builder.mutation({
            invalidatesTags: ['parameterGroundwaterStorage'],
            query: (data)=>({url: "core/hydrodynamic/storage/groundwater", method: "POST", data})
        }),
        parameterGroundStorageUpdate: builder.mutation({
            invalidatesTags: ['parameterGroundwaterStorage'],
            query: (data)=>({url: "/core/hydrodynamic/storage/groundwater/"+data.id, method: "PUT", data})
        }),
    
        parameterGroundStorageDelete: builder.mutation({
            invalidatesTags: ['parameterGroundwaterStorage'],
            query: (id)=>({url: "/core/hydrodynamic/storage/groundwater/"+id, method: "DELETE"})
        }),
    })
})

export const { useParameterGroundStorageFindAllQuery, useParameterGroundStorageCreateMutation, useParameterGroundStorageUpdateMutation, useParameterGroundStorageDeleteMutation } = StorageApi;
export {StorageApi};
